var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply-detail-page"},[(_vm.applyId)?_c('apply-detail',{attrs:{"apply-id":_vm.applyId,"can-approve":false}}):_c('div',{staticClass:"error-state"},[_c('el-empty',{attrs:{"description":"缺少申请ID参数"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }